import React, { useEffect, useState } from "react";
import { DataGridPro, GridColDef, GridSortModel, GridToolbarFilterButton } from '@mui/x-data-grid-pro';
import { Box, Button, IconButton, LinearProgress, Tooltip } from "@mui/material";
import { Add } from "@mui/icons-material";
import { taxesandfeesModel } from "../../models/TaxesAndFeesModel";
import { AddEditTaxesAndFees } from "../AddEdit/AddEditTaxesAndFees";
import RestoreFromTrashIcon from '@mui/icons-material/RestoreFromTrash';
import useAuth from "../../context/AuthProvider";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { RiExpandUpDownLine } from "react-icons/ri";
import { apiClient } from "../../helper/api";
import { KeyboardArrowUp, KeyboardArrowDown } from "@mui/icons-material";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import { formatUtcToLocal } from "../../helper/utils";

interface Iprops {
    taxesandfessCL: taxesandfeesModel[],
    loading: boolean,
    setLoading: (loading: boolean) => void,
    fetchData: () => void
}

export const TaxesAndFeesList: React.FC<Iprops> = ({ taxesandfessCL, loading, setLoading, fetchData }) => {
    const { user } = useAuth();
    const token = user?.token;
    const [SelectedMultiLOB, setSelectedMultiLOB] = React.useState<string[] | string>([]);
    const initialLBData: taxesandfeesModel = {
        id: 0,
        usstate: "",
        taxName: "",
        ratetype: 0,
        rate: 0,
        applicableto: "",
        lob: '',
        payableto: "",
        notes: "",
        dateCreated: new Date,
        dateModified: new Date,
        effectiveDate: "",
        isDeleted: false,
        stateId: 0,
        commaSeparatedLOBIds: "",
        taxPayee: "",
    }
    const [Open, setOpen] = React.useState(false);
    const [Formdata, setFormData] = React.useState(initialLBData);
    const initialdata = { id: 0, businessCode: "" };
    const [LineOfBusiness, setLineOfBusiness] = useState([initialdata]);
    const [sortModel, setSortModel] = useState<GridSortModel>([]);
    const columns: GridColDef[] = [
        {
            field: 'usstate', headerName: 'State', type: 'text', align: 'left', hideSortIcons: true,
            renderHeader: (params) => {
                const sortItem = sortModel.find(
                    (item: any) => item.field === 'usstate'
                  );
            
                const isSortedAsc = sortItem?.sort === 'asc';
                const isSortedDesc = sortItem?.sort === 'desc'
                return (
                    <div>
                        <span className="table-card-title">{params.colDef.headerName}</span>
                        {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                    </div>
                )
            }, headerAlign: 'left', minWidth: 100,
            flex: 0.7
        },
        {
            field: 'taxName', headerName: 'Tax Name', type: 'text', flex: 1, align: 'left', hideSortIcons: true,
            renderHeader: (params) => {
                const sortItem = sortModel.find(
                    (item: any) => item.field === 'taxName'
                  );
            
                const isSortedAsc = sortItem?.sort === 'asc';
                const isSortedDesc = sortItem?.sort === 'desc'
                return (
                    <div>
                        <span className="table-card-title">{params.colDef.headerName}</span>
                        {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                    </div>
                )
            }, headerAlign: 'left', minWidth: 130,
        },
        {
            field: 'rate', headerName: 'Rate', type: 'number', flex: 0.3, align: 'right', hideSortIcons: true, minWidth: 100,
            renderHeader: (params) => {
                const sortItem = sortModel.find(
                    (item: any) => item.field === 'rate'
                  );
            
                const isSortedAsc = sortItem?.sort === 'asc';
                const isSortedDesc = sortItem?.sort === 'desc'
                return (
                <div>
                    <span className="table-card-title" >{params.colDef.headerName}</span>
                        {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                    </div>
                )
            }, headerAlign: 'right'
        },
        {
            field: 'ratetype', type: 'text', headerName: 'Rate Type', flex: 0.7, hideSortIcons: true, minWidth: 150,
            renderHeader: (params) => {
                const sortItem = sortModel.find(
                    (item: any) => item.field === 'ratetype'
                  );
            
                const isSortedAsc = sortItem?.sort === 'asc';
                const isSortedDesc = sortItem?.sort === 'desc'
                return (
                    <div>
                        <span className="table-card-title">{params.colDef.headerName}</span>
                        {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                    </div>
                )
            }, headerAlign: 'left', align: 'left', valueGetter: (params) => (params.row.rateTypeName ?? (params.row.ratetype ? "Dollar" : "Percentage"))
        },
        {
            field: 'taxPayee', headerName: 'Tax Payee', flex: 1, type: 'singleSelect', hideSortIcons: true,
            renderHeader: (params) => {
                const sortItem = sortModel.find(
                    (item: any) => item.field === 'taxPayee'
                  );
            
                const isSortedAsc = sortItem?.sort === 'asc';
                const isSortedDesc = sortItem?.sort === 'desc'
                return (
                <div>
                    <span className="table-card-title" >{params.colDef.headerName}</span>
                        {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                    </div>
                )
            }, align: 'left', headerAlign: 'left', minWidth: 130,

        },
        {
            field: 'commaSeparatedLOBIds', headerName: 'Line of Business', width: 180, align: 'left', hideSortIcons: true,
            renderHeader: (params) => {
                const sortItem = sortModel.find(
                    (item: any) => item.field === 'commaSeparatedLOBIds'
                  );
            
                const isSortedAsc = sortItem?.sort === 'asc';
                const isSortedDesc = sortItem?.sort === 'desc'
                return (
                <div>
                    <span className="table-card-title" >{params.colDef.headerName}</span>
                    {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                </div>
                )},
                headerAlign: 'left',
                },
        {
            field: 'payableto', headerName: 'Payable To', flex: 0.6, align: 'left', hideSortIcons: true, minWidth: 150,
            renderHeader: (params) => {
                const sortItem = sortModel.find(
                    (item: any) => item.field === 'payableto'
                  );
            
                const isSortedAsc = sortItem?.sort === 'asc';
                const isSortedDesc = sortItem?.sort === 'desc'
                return (
                <div>
                    <span className="table-card-title" >{params.colDef.headerName}</span>
                    {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                </div>
            )
            }, headerAlign: 'left',
        },
        {
            field: 'notes', headerName: 'Notes', flex: 1, align: 'left', hideSortIcons: true, minWidth: 150,
            renderHeader: (params) => {
                const sortItem = sortModel.find(
                    (item: any) => item.field === 'notes'
                  );
            
                const isSortedAsc = sortItem?.sort === 'asc';
                const isSortedDesc = sortItem?.sort === 'desc'
                return (
                <div>
                    <span className="table-card-title" >{params.colDef.headerName}</span>
                    {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                </div>
                )
            }, headerAlign: 'left',
        },
        {
            field: 'effectiveDate', type: 'text', headerName: 'Effective Date', flex: 1, headerAlign: 'left', hideSortIcons: true, minWidth: 150,
            renderHeader: (params) => {
                const sortItem = sortModel.find(
                    (item: any) => item.field === 'effectiveDate'
                  );
            
                const isSortedAsc = sortItem?.sort === 'asc';
                const isSortedDesc = sortItem?.sort === 'desc'
                return (
                <div>
                    <span className="table-card-title" >{params.colDef.headerName}</span>
                    {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                </div>
                )
            }, align: 'left',
            valueGetter: (params) => {
                if (!params.value) {
                    return params.value;
                }
                return formatUtcToLocal(params.row?.effectiveDate, "MM-DD-YYYY")
            }
        },
        {
            field: 'id',
            flex: 0.7,
            headerName: "Action",
            align: 'left',
            headerAlign: 'left',
            minWidth: 90,
            disableColumnMenu: true,
            renderCell: (params) => (
                <div>
                    {user?.userRoles.split(",").includes("Super Admin") ||
                        user?.userRoles.split(",").includes("MISC Filer") ?
                        <IconButton
                            color="primary"
                            onClick={() => { handleEdit(params.row) }}
                            sx={{ color: 'rgba(255,255,255,0.9)', '&:hover': { color: '#fff', backgroundColor: 'rgba(32,153,210,0.15) !important' } }}
                        >
                            <Tooltip
                                title="Edit"
                                placement="top"
                                arrow
                            >
                            <EditOutlinedIcon fontSize="small" color="primary" />
                            </Tooltip>
                        </IconButton >
                        : ""}
                    {user?.userRoles.split(",").includes("Super Admin") ?
                        <IconButton
                            color="error"
                            onClick={() => { handleDelete(params.row.id) }}
                            sx={{ color: 'rgba(255,255,255,0.9)', '&:hover': { color: '#fff', backgroundColor: 'rgba(211,48,47,0.15) !important' } }}
                        >
                            {params.row.isDeleted ? (
                                <Tooltip
                                    title="Restore"
                                    placement="top"
                                    arrow
                                >
                                    <RestoreFromTrashIcon />
                                </Tooltip>
                            ) : (
                            <Tooltip
                                title="Delete"
                                placement="top"
                                arrow
                            >
                                <DeleteOutlinedIcon fontSize="small" color="error" />
                            </Tooltip>
                            )}
                        </IconButton >
                        : ""}
                </div>
            )
        },
    ];

    const handleClickOpen = () => {
        setFormData(initialLBData);
        setOpen(true);
        setSelectedMultiLOB([]);
    };

    function fetchLOBData(sateid: string) {
        apiClient(`/LineOfBusiness/getLineOBusinessByStateId?stateId=${sateid}`, {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            }),
        })
        .then((responseJson) => {
            if (responseJson?.data != null) {
                setLineOfBusiness(responseJson.data);
            }
        })
    };

    const handleSubmit = () => {
        fetchData();
        setOpen(false);
    };

    const handleEdit = (ILobData: taxesandfeesModel) => {
        fetchLOBData(ILobData.stateId?.toString() ?? "");
        const commaSeparatedLOBIds: string[] = ILobData.lob?.split(',') || [];
        const LOBIds: number[] = commaSeparatedLOBIds.map(id => Number(id));

        setLoading(true);

        let a: taxesandfeesModel = {
            id: ILobData.id,
            stateId: ILobData.stateId,
            lob: ILobData.lob,
            usstate: ILobData.usstate,
            taxName: ILobData.taxName,
            ratetype: ILobData.ratetype,
            rate: ILobData.rate,
            taxPayee: ILobData.taxPayee,
            payableto: ILobData.payableto,
            effectiveDate: ILobData.effectiveDate ? ILobData.effectiveDate.toString().split('T')[0] : "",
            notes: ILobData.notes
        }
        let lobs = ILobData.lob?.split(',') ?? [];

        let f = lobs.map(e => e.trim());

        setSelectedMultiLOB(f);
        setFormData(a);
        setOpen(true);
    };

    const handleDelete = (id: number) => {
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            iconHtml: '<svg width="70" height="70" viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="31" cy="31" r="31" fill="#2099d2"/><path d="M31.0003 25.6667V31M31.0003 36.3334H31.0137M44.3337 31C44.3337 38.3638 38.3641 44.3334 31.0003 44.3334C23.6365 44.3334 17.667 38.3638 17.667 31C17.667 23.6362 23.6365 17.6667 31.0003 17.6667C38.3641 17.6667 44.3337 23.6362 44.3337 31Z" stroke="white" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
            showCancelButton: true,
            confirmButtonColor: '#2099d2',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Delete',
            customClass: {
                confirmButton: 'btn-radius',
                cancelButton: 'btn-radius',
                popup: 'card-radius'
            }
        })
        .then((result) => {
            if (result.isConfirmed) {
                apiClient(`/TaxesAndFees/Delete/${id}`,
                    {
                        headers: new Headers({
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${token}`,
                        }),
                        method: "Delete",
                    }
                )
                .then((res) => {
                    if (!res) return
                    Swal.fire(
                        'Deleted!',
                        'Your file has been deleted.',
                        'success'
                    )
                    fetchData();
                    setOpen(false);
                })
            }
        })
    };

    function EditToolbar() {
        return (<Box sx={{
            borderBottom: 1,
            borderColor: 'divider',
            p: 1,
        }}>
            <GridToolbarFilterButton />
            </Box>
        );
    }

    return (
        <div style={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
            <>
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: 1.5,
                        px: { xs: 4, lg: 2 },
                        py: 1.5,
                        borderBottom: "1px solid #e2e8f0",
                        backgroundColor: "#fafbfc",
                        minHeight: 56,
                        mb: 3,
                        marginLeft: { xs: '-24px', lg: '0px' },
                        marginRight: { xs: '-24px', lg: '0px' },
                    }}
                >
                    <h4 className="mb-0" style={{ fontWeight: 600, color: "#0f172a" }}>
                        Surplus Line Taxes/Fees
                    </h4> 
                    <Button
                        variant="contained"
                        size="medium"
                        onClick={handleClickOpen}
                        startIcon={<Add />}
                        sx={{
                            textTransform: 'none',
                            fontWeight: 600,
                            backgroundColor: '#2099d2',
                            '&:hover': { backgroundColor: '#176990' },
                        }}
                    >
                        Add New
                    </Button>
                </Box>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        minHeight: 0,
                        borderRadius: '12px',
                        overflow: 'hidden',
                        boxShadow: '0 4px 24px rgba(15, 23, 42, 0.08), 0 1px 3px rgba(15, 23, 42, 0.06)',
                        border: '1px solid #e2e8f0',
                        backgroundColor: '#ffffff',
                        height: 'calc(100vh - 250px)',
                        position: 'relative',
                    }}
                >
                    {loading && (
                        <Box
                            position="absolute"
                            top={0}
                            left={0}
                            right={0}
                            bottom={0}
                            display="flex"
                            alignItems="center"
                            justifyContent="center"
                            sx={{
                                backgroundColor: "rgba(250, 251, 252, 0.85)",
                                zIndex: 10,
                                border: "1px solid #e2e8f0",
                                borderRadius: 1,
                            }}
                        >
                            <Box sx={{ width: "100%", maxWidth: 320 }}>
                                <LinearProgress color="info" sx={{ backgroundColor: "#e2e8f0", "& .MuiLinearProgress-bar": { backgroundColor: "#132D3D" } }} />
                                <Box sx={{ mt: 1.5, textAlign: "center" }}>
                                    <span style={{ fontSize: "14px", fontWeight: 600, color: "#475569" }}>Loading...</span>
                                </Box>
                            </Box>
                        </Box>
                    )}
                    <DataGridPro
                        getRowId={(r) => r.id}
                        rows={taxesandfessCL}
                        columns={columns}
                        pageSize={20}
                        rowsPerPageOptions={[20]}
                        components={{
                            Toolbar: EditToolbar,
                        }}
                        sx={{
                            fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
                            border: 'none',
                            fontSize: '14px',
                            color: '#475569',
                            backgroundColor: '#ffffff',
                            '& .MuiDataGridPro-columnHeaderTitle': {
                                whiteSpace: 'normal',
                                lineHeight: 1.35,
                                fontWeight: 600,
                                fontSize: '12px',
                                letterSpacing: '0.05em',
                                textTransform: 'uppercase',
                                color: '#64748b',
                            },
                            '& .MuiDataGrid-columnHeaders': {
                                backgroundColor: '#f8fafc',
                                borderBottom: '2px solid #e2e8f0',
                                borderTop: '2px solid #e2e8f0',
                                minHeight: '52px !important',
                                maxHeight: '52px !important',
                            },
                            '& .MuiDataGrid-columnHeader': {
                                '&:focus, &:focus-within': { outline: 'none' },
                            },
                            '& .MuiDataGrid-row': {
                                transition: 'background-color 0.15s ease',
                                '&:nth-of-type(even)': {
                                    backgroundColor: '#fafbfc',
                                },
                                '&:hover': {
                                    backgroundColor: '#f1f5f9 !important',
                                },
                            },
                            '& .MuiDataGrid-cell': {
                                borderBottom: '1px solid #f1f5f9',
                                fontSize: '14px',
                                color: '#334155',
                                overflow: 'visible',
                                whiteSpace: 'normal',
                                lineHeight: 'normal',
                                wordWrap: 'break-word',
                                textOverflow: 'clip',
                                padding: '8px 16px',
                                '&:focus': { outline: 'none' },
                            },
                            '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
                                marginBottom: '0px !important',
                            },
                            '& .MuiDataGrid-virtualScroller': {
                                border: 'none',
                            },
                            '& .MuiDataGrid-main': {
                                border: 'none',
                            },
                            '& .MuiDataGrid-footerContainer': {
                                borderTop: '1px solid #e2e8f0',
                                backgroundColor: '#f8fafc',
                                minHeight: 56,
                            },
                            '& .MuiTablePagination-root': {
                                color: '#64748b',
                                fontSize: '13px',
                            },
                            '& .MuiTablePagination-select': {
                                fontSize: '13px',
                                borderRadius: '6px',
                                border: '1px solid #e2e8f0',
                            },
                            '& .MuiIconButton-root': {
                                color: '#64748b',
                                '&:hover': {
                                    backgroundColor: '#f1f5f9',
                                    color: '#475569',
                                },
                            },
                        }}
                    />
                </Box>
            </>
            <AddEditTaxesAndFees handleClose={handleSubmit} Open={Open} taxesandfessCL={Formdata} initValues={initialLBData} fetchLOBData={fetchLOBData} LineOfBusiness={LineOfBusiness} setSelectedMultiLOB={setSelectedMultiLOB} SelectedMultiLOB={SelectedMultiLOB}></AddEditTaxesAndFees>
        </div>
    )
}
